import { Link } from 'react-router-dom';
import { TwoFactorCard } from '@/app/pages/profile/my-profile-page';
import { useAuth } from '@/contexts/auth-context';
import { getMFAEnrollmentAccount } from '@/lib/mfa-enrollment-account';

export function MFAEnrollmentPage() {
  const { user } = useAuth();
  const account = user?.email || getMFAEnrollmentAccount();

  return (
    <div className="w-full max-w-2xl space-y-4">
      <div className="text-center">
        <img src="/logos/h3ight.svg" alt="H3ight" className="mx-auto mb-4 h-8" />
        <h1 className="text-2xl font-bold">Secure your account</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Complete two-factor authentication setup to access your organization.
        </p>
        {account && (
          <p className="mt-2 text-sm text-muted-foreground">
            Signed in as <span className="font-medium text-foreground">{account}</span>
          </p>
        )}
      </div>
      <TwoFactorCard
        forced
        onEnrollmentComplete={() => {
          window.location.href = '/';
        }}
      />
      <div className="text-center">
        <Link
          to="/logout"
          className="text-sm text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
        >
          Sign out
        </Link>
      </div>
    </div>
  );
}
